import * as _ from 'lodash';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { SearchTextPipe } from '../../pipes/search-text.pipe';

@Component({
  selector: 'app-options-card',
  template: `
    <mat-card appearance="outlined">
      <mat-card-title [ngClass]="{ collapsed: collapsed }" fxLayout="row" fxLayoutAlign="start center">
        <span matTooltip="Select All" style="padding: 0 10px">
          <mat-checkbox [id]="selectAllId" [checked]="isAllSelected" (change)="selectAllOptions($event)"></mat-checkbox>
        </span>
        <span fxFlex>{{ title }}</span>
        <button type="button" mat-icon-button (click)="toggleCollapse()">
          <mat-icon *ngIf="!collapsed">expand_more</mat-icon>
          <mat-icon *ngIf="collapsed">expand_less</mat-icon>
        </button>
      </mat-card-title>
      <mat-card-content>
        <div *ngIf="!collapsed">
          <mat-form-field appearance="outline" class="regular-form-field no-label" *ngIf="showSearchInput">
            <input
              matInput
              type="text"
              placeholder="Search"
              [(ngModel)]="searchTextInput"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
          <div class="card-content">
            <div
              class="regular-form-field checkbox"
              *ngFor="let option of options | searchText: searchTextInput : 'text'; let i = index"
            >
              <mat-checkbox
                style="padding: 0 10px"
                class="no-margin"
                [value]="option.value"
                [id]="option.id"
                [checked]="valueIsChecked(option.value)"
                (change)="updateCheckedOptions(option, $event)"
                >{{ option.text }}
              </mat-checkbox>
            </div>
          </div>
          <ng-content></ng-content>
        </div>
      </mat-card-content>
    </mat-card>
  `,
  styles: ['.mat-mdc-card-title.collapsed {margin-bottom: 0; }', '.card-content {max-height: 250px; overflow: auto }'],
  standalone: true,
  imports: [
    MatCard,
    MatCardTitle,
    FlexModule,
    NgClass,
    MatTooltip,
    MatCheckbox,
    MatIconButton,
    NgIf,
    MatIcon,
    MatCardContent,
    MatFormField,
    MatInput,
    FormsModule,
    NgFor,
    SearchTextPipe,
  ],
})
export class CardOptionsComponent implements OnChanges, OnInit {
  @Input() title: string;
  @Input() showSearchInput = false;
  @Input() collapsed = false;
  @Input() emptyIsAll = false;
  @Input() options: any[] = [];
  @Input() checkedOptions: any[] = [];
  @Output() checkedOptionsChange = new EventEmitter();

  isAllSelected = false;
  selectAllId: string;
  searchTextInput: string;

  constructor() {
    this.selectAllId = _.uniqueId('id_');
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('changes');
    if (this.options.length > 0) {
      // remove values from checked options if not exist in select options
      const validCheckedOptions: any[] = [];
      for (const checkedOption of this.checkedOptions) {
        let optionFound = false;
        for (const option of this.options) {
          if (option.value instanceof Array) {
            if (option.value.indexOf(checkedOption) > -1) {
              optionFound = true;
              break;
            }
          } else {
            if (option.value === checkedOption) {
              optionFound = true;
              break;
            }
          }
        }
        if (!optionFound) {
          validCheckedOptions.push(checkedOption);
        }
      }

      _.pullAll(this.checkedOptions, validCheckedOptions);
      this.updateIsAllSelected()
    }
  }

  updateIsAllSelected() {
    this.isAllSelected = this.checkedOptions.length === this.options.length || (this.emptyIsAll && this.checkedOptions.length === 0);
  }

  ngOnInit() {
    // console.log(this.optionsMap);
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }

  valueIsChecked(value) {
    if (value instanceof Array) {
      const diff = _.difference(value, this.checkedOptions);
      return this.checkedOptions.length > 0 && diff.length === 0;
    } else {
      return this.checkedOptions.indexOf(value) >= 0;
    }
  }

  updateCheckedOptions(option, event) {
    if (event.checked) {
      if (option.value instanceof Array) {
        this.checkedOptions = _.union(this.checkedOptions, option.value);
      } else {
        if (this.checkedOptions.indexOf(option.value) === -1) {
          this.checkedOptions.push(option.value);
        }
      }
    } else {
      if (option.value instanceof Array) {
        _.pullAll(this.checkedOptions, option.value);
      } else {
        const index = this.checkedOptions.indexOf(option.value);
        if (index >= 0) {
          this.checkedOptions.splice(index, 1);
        }
      }
    }
    this.updateIsAllSelected();
    this.checkedOptionsChange.emit(this.checkedOptions);

    console.log(this.checkedOptions);
  }

  selectAllOptions(event) {
    this.checkedOptions = [];
    if (event.checked) {
      for (let i = 0; i < this.options.length; i++) {
        const option = this.options[i];
        if (option.value instanceof Array) {
          this.checkedOptions = _.union(this.checkedOptions, option.value);
        } else {
          if (this.checkedOptions.indexOf(option.value) === -1) {
            this.checkedOptions.push(option.value);
          }
        }
      }
    }
    this.updateIsAllSelected();
    this.checkedOptionsChange.emit(this.checkedOptions);
    console.log(this.checkedOptions);
  }
}
